import { gql } from "@apollo/client/core";

export default gql`
  query DataSheetsQuery {
    entityLocationSummaries {
      _id
      name
    }
      
      getCategories {
          _id
          slug

          subcategories {
              _id
              slug
          }
      }

  }
`;
